import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Load} from "../_decorators/loading.decorator";
import {FixDates} from "../_decorators/date.decorator";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class PolicyService {
    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }
  @Load()
  savePolicy(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/policies', result);
  }
  @Load()
  setPolicyOrder(order: number[]) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/policies/order', order);
  }
  @FixDates()
  @Load()
  getAllPolicysFull() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/policies/full');
  }
  @FixDates()
  getAllPolicys() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/policies');
  }
  @FixDates()
  getPolicy(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/policies/' + id);
  }

  @Load()
  setActive(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/policies/activate/' + id);
  }@Load()
  setInactive(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/policies/deactivate/' + id);
  }

  @Load()
  deletePolicy(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/policies/' + id);
  }

  @Load()
  uploadFile(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/policies/upload', formData)
      ;
  }

  @Load()
  importPolicy(entity: File, overwriteConfirmed: boolean) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + `/api/policies/import/` + overwriteConfirmed, formData);
  }

  @Load()
  exportPolicy(policyId, projectId): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/policies/export/' + policyId + '/' + projectId, {responseType: 'arraybuffer', headers: {}});
  }

  @Load()
  compare(policyText, text): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post(this.config.api + '/api/llm/generate', { targetText: policyText, text });
  }
}
